import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { ApisService } from './services/apis.service';
import { MetafieldsService } from './services/metafields.service';
import { CanonicalService } from './services/canonical.service';
import { Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title ='universal';
loadingFlag : boolean = false;
anim : any;
isLoading :boolean =true;

progressRef: NgProgressRef | any;
loader:boolean = false;
positionLoading:any = "left";
  isPopState: boolean=false;
  toggle : boolean = false;
  constructor(
    private metatagservice: Meta,
    private canonicalService: CanonicalService,
    private renderer: Renderer2,
    public api:ApisService,
    private progress: NgProgress,
    @Inject(DOCUMENT) private dom: any,
    private router: Router,@Inject(PLATFORM_ID) private platformId: any,
    private meta:MetafieldsService){
    this.router.events.subscribe(event => {
      // Scroll to top if accessing a page, not via browser history stack
      if (event instanceof NavigationEnd && !this.isPopState) {
        if(isPlatformBrowser(this.platformId)){
          if(document.getElementsByTagName('body')[0].clientWidth > 991){
            this.positionLoading = "center";
          }else{
            this.positionLoading = "center";
          }
          window.scrollTo(0, 0);
        }
        this.isPopState = false;
      }

      // Ensures that isPopState is reset
      if (event instanceof NavigationEnd) {
        this.isPopState = false;
      }
    });

  }

  updateToggle(){
    this.toggle = !this.toggle;
    console.log("hello , " , this.toggle)
  }

  ngOnInit():void{
    this.renderer.addClass(document.body, 'loading');
//     this.metatagservice.addTags([
// { name:'description', content:'Vidhema Technologies is a prominent top web and mobile app development company in India & Singapore, providing custom website development services across the world. Outsource web application development & expand your business globally.'},
// { name:'keyword', content:'web design company, web development agency, ecommerce development services, outsource web application development, custom website development services, custom web development company, web application framework, best website design, Top mobile app development company.'},
// { name:'revisit-after', content:'7 days'},
// { name:'author', content:'Vidhema Technology'},
// { name:'robots', content:'index, follow'},
// { name:'language', content:'English'},
// { property:'og:type', content:'https://www.vidhema.com/'},
// { property:'og:title', content:'Vidhema Technologies: Mobile App Development Company India, Singapore'},
// { property:'og:description', content:'Vidhema Technologies is a prominent top web and mobile app development company in India & Singapore, providing custom website development services across the world. Outsource web application development & expand your business globally.'},
// { property:'og:url', content:'https://www.vidhema.com/'},
// { property:'og:site_name', content:'Vidhema Technologies Pte. Ltd.'},
// { property:'og:image', content:'https://images.vidhema.com/Vidhema/VidhemaBlogImages/2021322124931-498vidhema-logoblack1.png.'},
// { name:'twitter:card', content:'summary_large_image'},
// { name:'twitter:description', content:'Vidhema Technologies is a prominent top web and mobile app development company in India & Singapore, providing custom website development services across the world. Outsource web application development & expand your business globally.'},
// { name:'twitter:title', content:'Vidhema Technologies: Mobile App Development Company India, Singapore'},
// { name:'twitter:site', content:'@vidhema1'},
// { name:'twitter:image', content:'https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg'},
// { name:'twitter:creator', content:'@vidhema1'},

//     ]);
    this.progressRef = this.progress.ref('myProgress');
    // this.meta.setCanonicalURL();
    this.canonicalService.updateCanonicalUrl();
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.setCanonicalURL(event.urlAfterRedirects);
    });
    window.addEventListener('load', () => {
      this.renderer.removeClass(document.body, 'loading');
      this.isLoading = false;
    });
  }
  ngAfterViewInit() {
    this.api.loading.subscribe((value)=>{
      if(value == true){
        this.progressRef.start();
      }else{
        this.progressRef.complete();
      }
    })
}
  animationCreated(anim: any) {
    this.anim = anim;
}
setCanonicalURL(url: string) {
  const link: HTMLLinkElement = this.dom.querySelector('link[rel="canonical"]') || this.renderer.createElement('link');
  this.renderer.setAttribute(link, 'rel', 'canonical');
  this.renderer.setAttribute(link, 'href', `https://vidhema.com${url}`);
  
  if (!this.dom.querySelector('link[rel="canonical"]')) {
    this.renderer.appendChild(this.dom.head, link);
  }
}
}
